import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\GetUserListController::__invoke
* @see app/Http/Controllers/User/GetUserListController.php
* @route '/api/user'
*/
const GetUserListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserListController.url(options),
    method: 'get',
})

GetUserListController.definition = {
    methods: ["get","head"],
    url: '/api/user',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\User\GetUserListController::__invoke
* @see app/Http/Controllers/User/GetUserListController.php
* @route '/api/user'
*/
GetUserListController.url = (options?: RouteQueryOptions) => {
    return GetUserListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\GetUserListController::__invoke
* @see app/Http/Controllers/User/GetUserListController.php
* @route '/api/user'
*/
GetUserListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetUserListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\User\GetUserListController::__invoke
* @see app/Http/Controllers/User/GetUserListController.php
* @route '/api/user'
*/
GetUserListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetUserListController.url(options),
    method: 'head',
})

export default GetUserListController